export const OfficeCreateEditRebateState = {
	url: '/rebate/:id',
	title: 'Office Create/Edit Rebate',
	params: {
		id: null,
	},
	template: '<create-edit-rebate-page></create-edit-rebate-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeCreateRebatePageMod" */
			'@Containers/office-rebate-discounts-page/office-create-edit-rebate/office-create-edit-rebate-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
